
















import { ResourceItem } from "@megarax/client/src/resources/ResourceItem";
import { useActions } from "@/shared/useMegaraxClient";
import {
  createComponent,
  ref,
  reactive,
  onBeforeUnmount,
} from "@vue/composition-api";
import { Resource } from "@megarax/client/src";
import { formValidator } from "@/shared/formValidator";
import { PostActions } from "@megarax/client/src/actions";
import { ResourceAppModule } from "../../shared/app";
import { getModulePath } from "../../apps/getPath";

interface Props<T extends ResourceItem> {
  module: ResourceAppModule;
}

export default createComponent<Props<any>>({
  name: "NewItemCard",
  components: {},
  props: {
    module: { required: true },
  },

  beforeRouteLeave(to: any, from: any, next: any) {
    if (
      (this as any).blockNavigation &&
      !window.confirm("Wyjść bez zapisywania?")
    ) {
      return;
    }
    next();
  },
  setup(props, ctx) {
    const blockNavigation = ref(true);

    const { formComponent } = props.module;

    const item: ResourceItem = reactive(new props.module.itemConstructor());

    const { form, validate } = formValidator();

    const actions = useActions(props.module.resource);

    async function onItemSaved(createdItem: ResourceItem) {
      blockNavigation.value = false;
      ctx.root.$router.push(getModulePath(props.module, createdItem.id!));
    }

    async function runValidation() {
      try {
        await (validate.value as any)();
      } catch (e) {
        ctx.root.$notify.error("Popraw błędy w formularzu.");
        throw e;
      }
    }

    // Prevent leaving the page
    function preventNav(event: BeforeUnloadEvent) {
      (event || window.event).returnValue = ""; //Gecko + IE
      return ""; //Gecko + Webkit, Safari, Chrome etc.
    }
    window.addEventListener("beforeunload", preventNav);

    onBeforeUnmount(() => {
      window.removeEventListener("beforeunload", preventNav);
    });

    return {
      actions,
      formComponent,
      form,
      item,
      onItemSaved,
      blockNavigation,
      runValidation,
    };
  },
});
